import { render, staticRenderFns } from "./adminDashboard.vue?vue&type=template&id=fdc53cd2&"
import script from "./adminDashboard.vue?vue&type=script&lang=js&"
export * from "./adminDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports